<div class="page-container" [class.loading]="isLoading">
    <app-header title="payroll.setup.payrollSetup" [menuService]="payrollModuleMenuService">
        <div class="buttons">
            <a href="https://humi.zendesk.com/hc/en-us/requests/new" target="_blank" rel=" noopener noreferrer">
                {{ 'payroll.setup.contactSupport' | translate }}
            </a>
        </div>
    </app-header>
    <ui-card [withMargin]="false">
        <h2>
            {{
                (isKYCKYBFlagEnabled() ? 'payroll.kyc-kyb.payroll-setup.title' : 'payroll.setup.supportingDocuments')
                    | translate
            }}
        </h2>
        <p class="margin-bottom-4">
            {{
                (isKYCKYBFlagEnabled()
                    ? 'payroll.kyc-kyb.payroll-setup.instructions'
                    : 'payroll.setup.humiNeedsTheFollowingInformationToVerifyTheSignedPAD'
                ) | translate
            }}
        </p>

        @if (isKYCKYBFlagEnabled()) {
            <ui-card variant="outline">
                <app-kyc-kyb-status scope="KYB" headingLevel="3" />
                <app-kyb-inquiries />
            </ui-card>
        } @else {
            <ng-container
                [ngTemplateOutlet]="legacyDocuments"
                [ngTemplateOutletContext]="{ readOnly: false }"
            ></ng-container>
        }
    </ui-card>

    @if (isKYCKYBFlagEnabled() && hasUploadedDocuments) {
        <ui-card>
            <h2 class="margin-bottom-2">
                {{ 'payroll.kyc-kyb.payroll-setup.legacy-documents' | translate }}
            </h2>
            <ng-container
                [ngTemplateOutlet]="legacyDocuments"
                [ngTemplateOutletContext]="{ readOnly: true }"
            ></ng-container>
        </ui-card>
    }
</div>

<ng-template #legacyDocuments let-readOnly="readOnly">
    @if (documents) {
        @for (documentType of documentTypes; track trackByType) {
            <app-supporting-documents-upload
                [readOnly]="readOnly"
                [document]="documents[documentType]"
                (upload)="getFile($event)"
            ></app-supporting-documents-upload>
        }
    }
</ng-template>

<input
    type="file"
    #fileInput
    [accept]="acceptableFileTypes.join(',')"
    (change)="uploadDocument($event.target)"
    class="d-none"
/>
